import React, { ChangeEvent } from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';

import { IBellAlert } from 'components/bellAlerts/types';
import { TUseBellAlerts } from 'hooks/useBellAlerts';

import styles from './markAsRead.module.scss';

interface MarkAsReadProps {
  handleRead: (event: ChangeEvent<{}>, id: IBellAlert['id']) => void;
  isRead: TUseBellAlerts['isRead'];
  id: IBellAlert['id'];
  idType: string;
}

const MarkAsRead = ({ handleRead, isRead, id, idType }: MarkAsReadProps) => {
  const { t } = useTranslation(['common']);

  return (
    (<button
      type="button"
      className={styles.markBox}
      onClick={event => handleRead(event, id)}
      data-testid="bellAlert-markAsRead-button"
      data-palette="MarkAsRead">
      {!isRead(id, idType) && (
        <Tooltip
          title={t('common:bellAlerts.markAsRead')}
          placement="left"
          classes={{
            popper: styles.tooltipPopper,
            tooltip: styles.tooltip,
            arrow: styles.tooltipArrow,
          }}
          arrow>
          <div className={styles.markBtn} />
        </Tooltip>
      )}
    </button>)
  );
};
export default MarkAsRead;
